import { render } from "./FormEasyPosComponent.vue?vue&type=template&id=7656aff0"
import script from "./FormEasyPosComponent.vue?vue&type=script&lang=js"
export * from "./FormEasyPosComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__